import { AxiosError } from "axios";
import { useQuery } from "react-query";
import axiosClient from "../utils/axiosClient";

export type ChapterItem = {
  summary: string;
  headline: string;
  gist: string;
  start: number;
  end: number;
};

export type ChaptersJSONResponse = ChapterItem[];

export const useChaptersJson = (url?: string) => {
  return useQuery<any, AxiosError<any>, ChaptersJSONResponse>(
    ["chaptersJson", url],
    () =>
      axiosClient.get<ChaptersJSONResponse>(url || "").then(({ data }) => data),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: !!url,
    }
  );
};
